import { jwtDecode } from "jwt-decode";
import useLoginStore from "../stores/loginStore";

export type UserRole = "admin" | "student";

interface DecodedToken {
  role: UserRole;
  // 다른 필요한 토큰 정보들...
}

export const getTokenRole = (): UserRole | null => {
  const token = useLoginStore.getState().token;
  if (!token) return null;

  try {
    const decoded = jwtDecode<DecodedToken>(token);
    return decoded.role;
  } catch (error) {
    console.error("Token decode error:", error);
    return null;
  }
};

export const hasRole = (requiredRole: UserRole): boolean => {
  const userRole = getTokenRole();
  return userRole === requiredRole;
};
